import { render, staticRenderFns } from "./OldWoononOrders.vue?vue&type=template&id=e44e113e"
import script from "./OldWoononOrders.vue?vue&type=script&lang=ts"
export * from "./OldWoononOrders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports